/**
 * Pure selection logic for the homepage's rotating editorial surfaces.
 * Everything is deterministic per local day (see dailyRotation) so the page
 * changes on return visits without flickering between renders.
 */
import type { BlogPost } from '../content/posts';
import { pickDaily, ROTATION_SALTS } from './dailyRotation';

/**
 * The "from the bank" coverline: a daily evergreen pick. Falls back to the
 * whole pool when nothing is flagged evergreen yet, and ignores exclusions
 * rather than returning nothing when the pool is small.
 */
export function selectEvergreenCoverline(
  pool: BlogPost[],
  excludeSlugs: string[],
  date?: Date
): BlogPost | undefined {
  const bank = pool.filter((post) => post.evergreen);
  const candidates = bank.length > 0 ? bank : pool;
  const excluded = new Set(excludeSlugs);
  const fresh = candidates.filter((post) => !excluded.has(post.slug));
  return pickDaily(fresh.length > 0 ? fresh : candidates, date, ROTATION_SALTS.coverline);
}
